import { Badge, DataList } from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { VideoFrameRateBadge } from 'components/common/video/frame-rate-badge';
import { VideoResolutionBadge } from 'components/common/video/resolution-badge';
import { parseISO } from 'date-fns';
import { format } from 'date-fns-tz';
import { t } from 'i18next';
import {
  LOCAL_PRETTY_DATETIME_FORMAT,
  LOCAL_TIMEZONE,
} from 'lib_ts/enums/datetime.enums';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { useVideosStore } from 'stores/use-videos-store';

const formatDate = (ds: string) =>
  format(parseISO(ds), LOCAL_PRETTY_DATETIME_FORMAT, {
    timeZone: LOCAL_TIMEZONE,
  });

export const VideoLibrarySidebarMiscDetails = () => {
  const selectedVideo = useVideosStore((s) => s.selectedVideo);

  if (!selectedVideo) {
    return null;
  }

  return (
    <ErrorBoundary identifier="VideoLibrarySidebarMiscDetails">
      <DataList.Root orientation="horizontal">
        {/* file name */}
        <DataList.Item>
          <DataList.Label>{t('common.file-name')}</DataList.Label>
          <DataList.Value>{selectedVideo.VideoFileName}</DataList.Value>
        </DataList.Item>

        {/* resolution */}
        <DataList.Item>
          <DataList.Label>{t('videos.resolution')}</DataList.Label>
          <DataList.Value>
            <VideoResolutionBadge value={selectedVideo} />
          </DataList.Value>
        </DataList.Item>

        {/* FPS */}
        <DataList.Item>
          <DataList.Label>{t('videos.frame-rate')}</DataList.Label>
          <DataList.Value>
            <VideoFrameRateBadge value={selectedVideo.fps} />
          </DataList.Value>
        </DataList.Item>

        {/* created */}
        <DataList.Item>
          <DataList.Label>{t('common.created')}</DataList.Label>
          <DataList.Value>{formatDate(selectedVideo._created)}</DataList.Value>
        </DataList.Item>

        {/* last updated */}
        <DataList.Item>
          <DataList.Label>{t('common.last-updated')}</DataList.Label>
          <DataList.Value>{formatDate(selectedVideo._changed)}</DataList.Value>
        </DataList.Item>

        {/* updated by */}
        <DataList.Item>
          <DataList.Label>{t('common.updated-by')}</DataList.Label>
          <DataList.Value>{selectedVideo.changer}</DataList.Value>
        </DataList.Item>

        {/* shared */}
        <DataList.Item>
          <DataList.Label>{t('common.shared')}</DataList.Label>
          <DataList.Value>
            <Badge
              color={
                selectedVideo.original_id
                  ? RADIX.COLOR.SUCCESS
                  : RADIX.COLOR.NEUTRAL
              }
            >
              {selectedVideo.original_id ? 'Yes' : 'No'}
            </Badge>
          </DataList.Value>
        </DataList.Item>
      </DataList.Root>
    </ErrorBoundary>
  );
};
